'use client';

import {
	Card, SimpleGrid, GridItem, Text,
} from '@chakra-ui/react';

import { NextImageWrapper } from '@/modules/shared/presentation';

import { useJobDetailContext } from './JobDetail';

export const SpecialInformation = () => {
	const { job } = useJobDetailContext();
	const { specialInfo } = job;

	return (
		<Card.Root bg="#027FC3">
			<Card.Header>
				<Card.Title
					color="white"
					textDecoration="underline"
					textDecorationColor="#FFE476"
					textDecorationThickness="4px"
					textStyle="h3"
					textUnderlineOffset={6}
				>
					Exclusively Special Information
				</Card.Title>
			</Card.Header>
			<Card.Body>
				<SimpleGrid
					bg="#FFFFFF"
					borderRadius="lg"
					columns={2}
					fontSize="16px"
					gap="lg"
					mt="sm"
					p="md"
				>
					<GridItem>
						<Text mt={4} textStyle="bodyBold">
							{specialInfo.topic}
						</Text>
						<Text color="gray.100">
							{specialInfo.description}
						</Text>
					</GridItem>
					<GridItem>
						<NextImageWrapper
							aspectRatio="wide"
							image={{
								alt: specialInfo.topic,
								src: specialInfo.image,
							}}
							w="100%"
						/>
					</GridItem>
				</SimpleGrid>
			</Card.Body>
		</Card.Root>
	);
};
